import {ClientStateContextSearchGateway} from "./clientstatecontextSearch.gateway";
import {ClientStateContextSearchResultModel, ClientStateContextSearchViewModel} from "./clientstatecontextSearch.viewmodel";
import * as LogService from "../../core/services/logservice/log.service";
import {ClientStateContextSearchCriteria} from "../../models/clientstatecontextsearchcriteria.model";
import * as _ from 'lodash';

export class ClientStateContextSearchController {

    private searchViewModel:ClientStateContextSearchViewModel;
    private searchCriteria:ClientStateContextSearchCriteria;
    private isDataGridLoading: boolean;

    static $inject = ['clientStateContextSearch.gateway', 'logService', 'clipboard'];

    constructor(private clientStateContextSearchGateway:ClientStateContextSearchGateway, private logger: LogService.ILogService, private clipboard:any)
    {
        this.searchViewModel = new ClientStateContextSearchViewModel();
        this.searchCriteria = new ClientStateContextSearchCriteria();
        this.searchCriteria.isComplete = false;
    }

    private submit(){

        this.isDataGridLoading = true;

        // if searchResultsGrid is already loaded then clear it so the spinner does not spin on top of data
        if (typeof(this.searchViewModel) != "undefined") {
            if (typeof (this.searchViewModel.searchResults) != "undefined") {
                this.searchViewModel.searchResults = undefined;
            }
        }

        const searchViewModelPromise: ng.IPromise<ClientStateContextSearchViewModel> = this.clientStateContextSearchGateway.loadViewModel(this.searchCriteria);
        searchViewModelPromise.then((viewModel: ClientStateContextSearchViewModel) => {
            this.logger.debug("searchViewModelPromise", viewModel);
            this.searchViewModel = viewModel;
            this.isDataGridLoading = false;
        });
    }

    public copyGridToClipboard(){

        let filteredProperties = [ 'primaryContactFirstName', 'primaryContactLastName', 'primaryContactEmail', 'primaryContactPhone', 'createdAt'];

        if (!this.clipboard.supported) {
            console.log('Sorry, copy to clipboard is not supported');
        }
        else{

            let results = "";

            if(this.searchViewModel.searchResults){
                _.forEach(this.searchViewModel.searchResults, (model:ClientStateContextSearchResultModel)=>{
                    results = results + this.modelToString(model,filteredProperties);
                })
            }
            else{
                results = "No Search Results";
            }

            this.clipboard.copyText(results);
        }
    }

    public modelToString(model: ClientStateContextSearchResultModel, filteredProperties:Array<string>):string{

        let result = "";

        let index = 0;


        _.forEach(filteredProperties, (prop)=>{

            let val = model[prop];

            if(val)
            {
                result = result + val;
            }
            else
            {
                result = result + 'null';
            }

            if(index+1 < filteredProperties.length){
                result = result + ',';
            }

            index = index + 1

        });

        return result + '\n';

    }

    public objectToSingleString<T>(obj: T):string{

        let result = "";

        //ordering properties to guarantee data stays in appropriate column when null
        let props = _.sortBy(Object.getOwnPropertyNames(obj));

        _.forEach(props, (key)=>{

            let val = obj[key];

            if(val)
            {
                result = result + val + ',';
            }
            else
            {
                result = result + 'null' + ',';
            }

        });

        return result + '\n';
    }

}